import React from "react";
import { Link } from "react-router-dom";

export default class MaintTabs extends React.Component {
  render() {
    let nav = {
      default: "ТО",
      element: "Оборудование",
    };

    const { structureId, itemId, mode } = this.props;
    return (
      <ul className="nav nav-tabs mb-4">
        {Object.entries(nav).map(([id, title]) => (
          <li className="nav-item w-lg-auto w-100" key={id}>
            <Link
              to={`/maint/${structureId}/${itemId}/${id}/`}
              className={` ${
                mode === id ? "active" : ""
              } cursor-pointer nav-link`}
            >
              {title}
            </Link>
          </li>
        ))}
      </ul>
    );
  }
}
